export default "__VITE_ASSET__CuN2mpoj__"